import ManualTecnico from "./ManualTecnico";
import Liquidez from "./Liquidez";
import ReportesCnbv from "./ReportesCnbv";
import { useState } from "react";
import { Hub } from "../components/crm/Hub";
import { Agenda } from "../components/actividad/Agenda";
import { ReporteActividad } from "../components/actividad/ReporteActividad";
import { Cotizador } from "../components/kit/Cotizador";
import { NewDealModal } from "../components/crm/NewDealModal";
import { Respaldos } from "../components/kit/Respaldos";
import Pipeline from "./Pipeline";
import Deals from "./Deals";
import Comite from "./Comite";
import Faltantes from "./Faltantes";
import LoanManagement from "./LoanManagement";
import CobranzaInt from "./CobranzaInt";
import Alertas from "./Alertas";
import Covenants from "./Covenants";
import RiesgoPortafolio from "./RiesgoPortafolio";
import Reportes from "./Reportes";
import LmReporting from "./LmReporting";
import DataTape from "./DataTape";
import ExpedientesDrive from "./ExpedientesDrive";
import PaqueteDatos from "./PaqueteDatos";
import Funding from "./Funding";
import Fondeo from "./Fondeo";
import Programa from "./Programa";
import Referenciadores from "./Referenciadores";
import Equipo from "./Equipo";
import Configuracion from "./Configuracion";
import Auditoria from "./Auditoria";
import Bitacora from "./Bitacora";
import { CapCartera } from "../components/captacion/CapCartera";
import { CapAhorradores } from "../components/captacion/CapAhorradores";
import { CapTasas } from "../components/captacion/CapTasas";
import { CapPipeline } from "../components/captacion/CapPipeline";
import { CapVencimientos } from "../components/captacion/CapVencimientos";
import { CapReportes } from "../components/captacion/CapReportes";
import { CapGraficas } from "../components/trading/CapCharts";
import { DocKitMuestras } from "../components/kit/DocKitMuestras";
import { Directorio } from "../components/directorio/Directorio";
import { Sugerencias } from "../components/directorio/Extras";
import { Tablero } from "../components/demanda/Tablero";
import { Solicitudes } from "../components/demanda/Solicitudes";
import { Campanas } from "../components/demanda/Campanas";
import { DemandaConfig } from "../components/demanda/DemandaConfig";
import { CamposAdmin } from "../components/campos/CamposAdmin";
import { Catalogo } from "../components/campos/Catalogo";
import AltasBoard from "./AltasBoard";

const Wrap = ({ children }) => <main className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-10">{children}</main>;

const CotizadorTab = () => {
  const [nd, setNd] = useState(null);
  const [k, setK] = useState(0);
  return <Wrap><Cotizador key={k} onClose={() => setK(k + 1)} onConvert={(q) => setNd(q)} />{nd && <NewDealModal prefill={nd} onClose={() => setNd(null)} />}</Wrap>;
};

export const OriginacionHub = () => <Hub group="originacion" elements={{ pipeline: <Pipeline />, deals: <Deals />, comite: <Comite />, cotizador: <CotizadorTab />, faltantes: <Faltantes /> }} />;
export const CaptacionHub = () => <Hub group="captacion" elements={{ cartera: <Wrap><CapCartera /></Wrap>, ahorradores: <Wrap><CapAhorradores /></Wrap>,
  "sin-asignar": <Wrap><CapAhorradores sinAsignar /></Wrap>, tasas: <Wrap><CapTasas /></Wrap>, pipeline: <Wrap><CapPipeline /></Wrap>, vencimientos: <Wrap><CapVencimientos /></Wrap>, graficas: <Wrap><CapGraficas /></Wrap>, reportes: <Wrap><CapReportes /></Wrap>, importar: <LoanManagement only={["captacion"]} vista="captacion" /> }} />;
export const CarteraHub = () => <Hub group="cartera" elements={{ creditos: <LoanManagement only={["cartera", "importar"]} vista="creditos" />, cobranza: <CobranzaInt />, alertas: <Alertas />, covenants: <Covenants />, expedientes: <ExpedientesDrive />,
  captacion: <LoanManagement only={["captacion"]} vista="captacion" />, completar: <LoanManagement only={["completar", "cierres"]} vista="completar" /> }} />;
export const RiesgoHub = () => <Hub group="riesgo" elements={{ portafolio: <RiesgoPortafolio />, liquidez: <Wrap><Liquidez /></Wrap>, cnbv: <Wrap><ReportesCnbv /></Wrap> }} />;
export const ReportesHub = () => <Hub group="reportes-fondeo" elements={{ reportes: <Reportes />, analitica: <LmReporting />, "data-tape": <DataTape />, lineas: <Fondeo />, fondeadores: <Funding /> }} />;
export const ClientesHub = () => <Hub group="clientes" elements={{ directorio: <Wrap><Directorio /></Wrap>, sugerencias: <Wrap><Sugerencias /></Wrap> }} />;
export const SociosHub = () => <Hub group="socios" elements={{ comisiones: <Programa only={["cortes", "datos", "config"]} />, referenciadores: <Referenciadores />, altas: <Wrap><AltasBoard /></Wrap> }} />;
export const AdminHub = () => <Hub group="admin" elements={{ equipo: <Equipo />, paquete: <PaqueteDatos />, configuracion: <Configuracion />, respaldos: <Wrap><Respaldos /></Wrap>, auditoria: <Auditoria />, bitacora: <Bitacora />, "manual-tecnico": <Wrap><ManualTecnico /></Wrap>, "formato-documentos": <Wrap><DocKitMuestras /></Wrap>, campos: <Wrap><CamposAdmin /></Wrap>, productos: <Wrap><Catalogo /></Wrap> }} />;
export const DemandaHub = () => <Hub group="demanda" elements={{ tablero: <Wrap><Tablero /></Wrap>, solicitudes: <Wrap><Solicitudes /></Wrap>, campanas: <Wrap><Campanas /></Wrap>, formularios: <Wrap><DemandaConfig /></Wrap> }} />;
export const ActividadHub = () => <Hub group="actividad" elements={{ agenda: <Wrap><Agenda /></Wrap>, reportes: <Wrap><ReporteActividad /></Wrap> }} />;
